<div
  id="conteudoParaPdfToi"
  style="margin: 0; padding: 0; font-size: 7px; font-family: Arial, sans-serif; background: #fff; width: 794px; box-sizing: border-box;">
  <!-- Página 1 — corpo do termo -->
  <div class="toi-pdf-pagina toi-pdf-corpo-pagina" style="box-sizing: border-box">
    <!-- Cabeçalho -->
    <section class="toi-pdf-secao-cabecalho">
      <div
        style="
          height: 70px;
          width: 100%;
          border: 1px solid #000;
          border-radius: 12px;
          background-color: #fdfdfd;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 30px;
          box-sizing: border-box;
          margin-bottom: 20px;
        "
      >
        <div style="width: auto; height: 40px; display: flex; align-items: center; justify-content: center">
          <img src="assets/layout/images/copasa.png" alt="Copasa" style="height: 40px; width: auto" />
        </div>
        <div style="flex-grow: 1; text-align: center; padding: 0 10px">
          <h2 style="margin: 0; font-size: 17px; color: #505050; line-height: 1.3">TERMO DE OCORRENCIA DE IRREGULARIDADE (REGULARIZAÇÃO PELA COPASA)</h2>
        </div>
        <div style="width: 100px; text-align: right">
          <span style="font-weight: bold; font-size: 9px">Página 1/{{ totalPaginas }}</span>
        </div>
      </div>
    </section>
  
    <!-- Dados iniciais -->
    <section class="toi-pdf-secao" style="font-size: 12px;">
      <table style="width: 100%; border: 1px solid #000; background-color: #fdfdfd; border-collapse: collapse">
        <tr>
          <td style="padding: 4px 6px 6px 6px; border: 1px solid #000; width: 33%; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">N° OS</strong>
            {{ pdfToi?.dadosHst?.numeroBa }}
          </td>
          <td style="padding: 4px 6px 6px 6px; border: 1px solid #000; width: 33%; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">DATA VISTORIA</strong>
            {{ dataVistoria | date: 'dd/MM/yyyy' }}
          </td>
          <td style="padding: 4px 6px 6px 6px; border: 1px solid #000; width: 34%; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">GERÊNCIA REGIONAL</strong>
            {{ pdfToi?.dadosHst?.dsGerenciaRegional }}
          </td>
        </tr>
        <tr>
          <td style="padding: 4px 6px 6px 6px; border: 1px solid #000; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">LOCALIDADE</strong>
            {{ pdfToi?.dadosHst?.dsLocalidade }}
          </td>
          <td colspan="2" style="padding: 4px 6px 6px 6px; border: 1px solid #000; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">N° DE UNIDADE POR CATEGORIA</strong>
            <span style="display: block; white-space: nowrap;"
              ><span style="display: inline-block; white-space: nowrap; margin-right: 6px;"
                >(<span style="display: inline-block; min-width: 16px; text-align: center;">{{ economiaColchete('residencial') }}</span>)<strong>Res.</strong></span
              ><span style="display: inline-block; white-space: nowrap; margin-right: 6px;"
                >(<span style="display: inline-block; min-width: 16px; text-align: center;">{{ economiaColchete('social') }}</span>)<strong>Soc.</strong></span
              ><span style="display: inline-block; white-space: nowrap; margin-right: 6px;"
                >(<span style="display: inline-block; min-width: 16px; text-align: center;">{{ economiaColchete('comercial') }}</span>)<strong>Com.</strong></span
              ><span style="display: inline-block; white-space: nowrap; margin-right: 6px;"
                >(<span style="display: inline-block; min-width: 16px; text-align: center;">{{ economiaColchete('industrial') }}</span>)<strong>Ind.</strong></span
              ><span style="display: inline-block; white-space: nowrap;"
                >(<span style="display: inline-block; min-width: 16px; text-align: center;">{{ economiaColchete('publica') }}</span>)<strong>Pub.</strong></span
              ></span
            >
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 4px 6px 6px 6px; border: 1px solid #000; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">ENDEREÇO DA UNIDADE USUÁRIA</strong>
            {{ pdfToi?.dadosHst?.dsEnderecoUnidade }}
          </td>
          <td style="padding: 4px 6px 6px 6px; border: 1px solid #000; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">MATRÍCULA IMÓVEL</strong>
            {{ pdfToi?.dadosHst?.nrMatriculaImovel }}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 4px 6px 6px 6px; border: 1px solid #000; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">USUÁRIO CADASTRADO (responsável pela unidade usuária)</strong>
            {{ pdfToi?.dadosHst?.nmUsuarioCadastrado }}
          </td>
          <td style="padding: 4px 6px 6px 6px; border: 1px solid #000; vertical-align: top; line-height: 1.15;">
            <strong style="display: block; margin: 0 0 1px 0;">IDENTIFICADOR USUÁRIO</strong>
            {{ pdfToi?.dadosHst?.nrIdentificadorUsuario?.trim() }}
          </td>
        </tr>
      </table>
    </section>
  
    <!-- Irregularidades -->
    <section class="toi-pdf-secao" style="font-size: 13px;">
      <table style="width: 100%; border: 1px solid #000; border-collapse: collapse">
        <tbody>
          <tr style="background-color: #fdfdfd">
            <td style="padding: 6px; border: 1px solid #000; line-height: 1.3; font-size: 12px;">
              <div style="font-weight: bold; font-size: 13px; text-align: left; margin-bottom: 2px;">
                IRREGULARIDADE/INFRACÃO DETECTADA
              </div>
              <ng-container *ngIf="tpToi === 'MODELO_1'">
                1 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('01_danificacao_tubulacoes'), 2) }}</span>] Danificação das tubulações ou instalações dos sistemas públicos de água e de esgoto<br />
                2 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('02_danificacao_hidrometro'), 2) }}</span>] Danificação do hidrômetro<br />
                3 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('03_derivacao_clandestina'), 2) }}</span>] Derivação clandestina no ramal externo [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('03_derivacao_agua'), 2) }}</span>] água [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('03_derivacao_esgoto'), 2) }}</span>] esgoto<br />
                4 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('04_extravio_hidrometro'), 2) }}</span>] Extravio/retirada do hidrômetro<br />
                5 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao'), 2) }}</span>] Intervenção [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_ramal_externo_agua'), 2) }}</span>] no ramal externo água [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_ponto_ligacao'), 2) }}</span>] no ponto de ligação [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_padrao'), 2) }}</span>] no padrão (conjunto de ligação)
                [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_rede_agua'), 2) }}</span>] na rede água<br />
                &nbsp;&nbsp;&nbsp;&nbsp;[<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_ramal_externo_esgoto'), 2) }}</span>] no ramal externo esgoto [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_poco_luminar'), 2) }}</span>] no poço luminar (caixa de inspeção pública) [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_intervencao_rede_esgoto'), 2) }}</span>] na
                rede esgoto<br />
                6 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('06_inversao_hidrometro'), 2) }}</span>] Inversão do hidrômetro<br />
                7 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('07_ligacao_clandestina_agua'), 2) }}</span>] Ligação clandestina água - situação ponto: [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('07_ponto_ativo'), 2) }}</span>] ativo [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('07_ponto_tamponado'), 2) }}</span>] tamponado [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('07_ponto_suprimido'), 2) }}</span>] suprimido [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('07_sem_ponto'), 2) }}</span>] sem ponto<br />
                <table style="width: 100%; border-collapse: collapse; margin: 0; padding: 0">
                  <tr>
                    <td style="width: 50%; padding: 0 8px 0 0; border: none; vertical-align: top">
                      8 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('08_ligacao_esgoto_nao_cadastrada'), 2) }}</span>] Ligação de esgoto não cadastrada
                    </td>
                    <td style="width: 50%; padding: 0; border: none; vertical-align: top">
                      9 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('09_obstrucao_rede_coletora'), 2) }}</span>] Obstrução da rede coletora, por mau uso
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 50%; padding: 0 8px 0 0; border: none; vertical-align: top">
                      10 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('10_informacao_falsa'), 2) }}</span>] Prestação de informação falsa ao prestador de serviço
                    </td>
                    <td style="width: 50%; padding: 0; border: none; vertical-align: top">
                      11 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('11_violacao_lacre'), 2) }}</span>] Violação do lacre [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('11_violacao_lacre_hidrometro'), 2) }}</span>] hidrômetro [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('11_violacao_lacre_padrao'), 2) }}</span>] padrão
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 50%; padding: 0 8px 0 0; border: none; vertical-align: top">
                      12 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('12_violacao_supressao_agua'), 2) }}</span>] Violação da supressão da ligação de água
                    </td>
                    <td style="width: 50%; padding: 0; border: none; vertical-align: top">
                      13 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('13_violacao_alerta_corte'), 2) }}</span>] Violação do alerta de corte (suspensão)
                    </td>
                  </tr>
                </table>
                14 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('14_violacao_tamponamento_esgoto'), 2) }}</span>] Violação do tamponamento da ligação de esgoto<br />
                15 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('15_violacao_tamponamento_agua'), 2) }}</span>] Violação do tamponamento da ligação de água [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('15_tamponamento_com_retirada_hidrometro'), 2) }}</span>] com retirada do hidrômetro [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('15_tamponamento_sem_retirada_hidrometro'), 2) }}</span>] sem retirada do
                hidrômetro<br />
                16 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('16_violacao_visivel_hidrometro'), 2) }}</span>] Violação visível do hidrômetro: [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('16_perfuracao_cupula'), 2) }}</span>] perfuração da cúpula/carcaça [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('16_vidro_quebrado'), 2) }}</span>] vidro quebrado [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('16_dispositivo_recurso'), 2) }}</span>] Utilização
                de dispositivo ou recurso que afete o funcionamento do hidrômetro [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('16_outros'), 2) }}</span>] Outros:<span style="color: #cc0000;"> {{ checklistValor('Preencher em caso de outros:') }}</span>
              </ng-container>

              <ng-container *ngIf="tpToi === 'MODELO_2'">
                  1 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('01_adulteracao_documentos'), 2) }}</span>] Adulteração de documentos emitidos pela Copasa, pelo usuário/terceiros, em seu benefício<br />
                  2 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('02_construcao_disposicao_material'), 2) }}</span>] Construção/disposição material que prejudica/impede acesso ao ramal até o ponto de ligação de água ou às redes água e esgoto localizadas em faixas de servidão<br />
                  3 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('03_descumprimento_obrigatoriedade_conectar_rede'), 2) }}</span>] Descumprimento da obrigatoriedade de conectar-se à rede de [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('03_descumprimento_obrigatoriedade_conectar_rede_agua'), 2) }}</span>] água [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('03_descumprimento_obrigatoriedade_conectar_rede_esgoto'), 2) }}</span>] esgoto<br />
                  4 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('04_descumprimento_outra_exigencia_tecnica'), 2) }}</span>] Descumprimento de qualquer outra exigência técnica estabelecida em lei, regulamentos, normas e resoluções<br />
                  5 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_despejo_aguas_pluviais_rebaixamento_lençol_freatico'), 2) }}</span>] Despejo de águas pluviais/rebaixamento lençol freático [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_despejo_aguas_pluviais_rebaixamento_lençol_freatico_nas_inst_prediais_esgoto'), 2) }}</span>] nas inst. prediais esgoto [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('05_despejo_aguas_pluviais_rebaixamento_lençol_freatico_nos_ramais_prediais_esgoto'), 2) }}</span>] nos ramais prediais esgoto<br />
                  6 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('06_desperdicio_agua_emergencia_calamidade_racionamento'), 2) }}</span>] Desperdício de água em situações de emergência, calamidade ou racionamento<br />
                  7 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('07_fornecimento_agua_terceiros'), 2) }}</span>] Fornecimento de água a terceiros (em lote, imóvel, terreno distintos), mediante a extensão dos ramais internos<br />
                  8 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('08_impedimento_injustificado_acesso_ramal_externo_interno_agua_esgoto'), 2) }}</span>] Impedimento injustificado de acesso ao ramal externo/interno de água ou esgoto, após previa comunicação ou após apresentação de documentação de identificação funcional<br />
                  9 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('09_instalacao_dispositivo_succao_rede_distribuidora_ramal_externo_agua'), 2) }}</span>] Instalação de dispositivo de sucção na rede distribuidora ou no ramal externo de água<br />
                  10 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('10_interconexao_instalacao_predial_abastecimento_proprio'), 2) }}</span>] Interconexão da instalação predial que possua abastecimento próprio com instalação alimentada com água procedente de abastecimento público<br />
                  11 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('11_lancamento_rede_esgoto_efluentes_nao_domesticos'), 2) }}</span>] Lançamento na rede de esgoto de efluentes não domésticos que não atendam às normas do Programa PRECEND<br />
                  12 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('12_nao_construcao_ou_nao_utilizacao_caixa_gordura_sifonada'), 2) }}</span>] Não construção ou não utilização de caixa de gordura sifonada na instalação predial de esgoto, ou outras caixas especiais definidas em normas específicas<br />
                  13 - [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarIrregularidade('13_recebimento_esgoto_terceiros'), 2) }}</span>] Recebimento de esgoto de terceiros (em lote, imóvel, terreno distinto), mediante a extensão dos ramais internos
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  
    <!-- ATENÇÃO (texto fixo) -->
    <section class="toi-pdf-secao">
      <table style="width: 100%; border: 1px solid #000; border-collapse: collapse">
        <tbody>
          <tr style="background-color: #fdfdfd">
            <td style="padding: 6px; border: 1px solid #000; line-height: 1.3; font-size: 12px;">
              <div style="font-weight: bold; font-size: 13px; text-align: left; margin-bottom: 2px;">
                <u>ATENÇÃO</u>:
              </div>
            <ng-container *ngIf="tpToi === 'MODELO_1'">
              1) A Copasa tomará as providências para eliminação da(s) infração(ões) identificada(s);<br />
              2) As infrações sujeitam o usuário à advertência, pagamento de multa (sanção pecuniária), ressarcimento dos
              prejuízos impostos ao prestador e/ou à interrupção da prestação do serviço. Os valores devidos serão lançados em
              fatura mensal;<br />
              3) É facultado ao usuário o direito de apresentar defesa formal no prazo <b><u>irrevogável</u></b> de até 15 (quinze) dias
              corridos da data de recebimento deste Termo. Acatando este termo, sem apresentação de recurso no prazo informado,
              o usuário abre mão de recurso futuro e faz jus ao desconto de 25% sobre o valor da sanção pecuniária;<br />
              4) Em caso de reincidência devidamente comprovada num período de até 04 anos a contar da data da identificação da
              infração, poderá ser cobrado em dobro os valores relativos à sanção pecuniária;<br />
              5) Para apresentar defesa formal deste termo, acesse o site www.copasa.com.br, “Agência Virtual /
              Infração/Irregularidade”;<br />
              6) A tabela de sanções pecuniárias aplicáveis encontra-se disponível no site acima informado.
            </ng-container>
              <ng-container *ngIf="tpToi === 'MODELO_2'">
              1) Tal(is) infração(ões) deve(m) ser regularizada(s) pelo usuário no prazo de 
              <strong>{{prazoDias}}</strong> dia(s) corridos a contar da data de recebimento deste Termo.
              A não regularização no prazo estipulado sujeita o usuário ao pagamento de multa (sanção pecuniária)
              e/ou à interrupção da prestação do serviço. <u>A regularização deve ser informada à Copasa</u> imediatamente
              após a sua execução de modo a permitir a confirmação e a interrupção de aplicação de sanção pecuniária
              mensal, se for o caso.<br />É também devido o ressarcimentos de eventuais prejuízos impostos ao prestador;<br />
              2) Os valores devidos serão lançados em fatura mensal;<br />
              3) É facultado ao usuário o direito de apresentar defesa formal no prazo <b><u>irrevogável</u></b> de até 15
              (quinze) dias corridos da data de recebimento deste Termo. Acatando este termo, sem apresentação de
              recurso no prazo informado, o usuário abre mão de recurso futuro e faz jus ao desconto de 25% sobre o
              valor da sanção pecuniária. O desconto não exime o usuário da obrigatoriedade da regularização;<br />
              4) Em caso de reincidência devidamente comprovada num período de até 04 anos a contar da data da
              identificação da infração, poderá ser cobrado em dobro os valores relativos à sanção pecuniária;<br />
              5) Para apresentar defesa formal deste termo ou comunicar a regularização da infração, acesse o site
              www.copasa.com.br, "Agência Virtual / Infração/Irregularidade";<br />
              6) A tabela de sanções pecuniárias aplicáveis encontra-se disponível no site acima informado.
            </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  
    <section class="toi-pdf-secao">
      <table style="width: 100%; border: 1px solid #000; border-collapse: collapse">
        <tbody>
          <tr style="background-color: #fdfdfd">
            <td style="padding: 8px; border: 1px solid #000; font-size: 11px;">
              <strong>Descrição da infração:</strong> (preenchimento obrigatório). <strong>O relatório fotográfico deve conter N° da OS
              e data da vistoria.</strong><br>
              <span style="display: block; margin-top: 6px; min-height: 40px">{{ descricaoInfracaoTexto() }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  
    <section class="toi-pdf-secao" style="font-size: 11px;" *ngIf="tpToi !== 'MODELO_2'">
      <table style="width: 100%; border: 1px solid #000; background-color: #fdfdfd; border-collapse: collapse">
        <tr>
          <td style="padding: 8px; border: 1px solid #000; width: 20%; vertical-align: top">
            <ng-container *ngTemplateOutlet="campoDuasLinhas; context: { label: 'N° Hidrometro:', valor: checklistValor('NUMERACAO DO HIDROMETRO:') }"></ng-container>
          </td>
          <td style="padding: 8px; border: 1px solid #000; width: 20%; vertical-align: top">
            <ng-container *ngTemplateOutlet="campoDuasLinhas; context: { label: 'N° Lacre:', valor: checklistValor('N° LACRE') }"></ng-container>
          </td>
          <td style="padding: 8px; border: 1px solid #000; width: 20%; vertical-align: top">
            <ng-container *ngTemplateOutlet="campoDuasLinhas; context: { label: 'Leitura retirada:', valor: checklistValor('LEITURA RETIRADA') }"></ng-container>
          </td>
          <td style="padding: 8px; border: 1px solid #000; width: 20%; vertical-align: top">
            <ng-container *ngTemplateOutlet="campoDuasLinhas; context: { label: 'Leitura instalação:', valor: checklistValor('LEITURA INSTALAÇÃO') }"></ng-container>
          </td>
          <td style="padding: 8px; border: 1px solid #000; width: 20%; vertical-align: top">
            <strong style="display: block; line-height: 1.3;">Localização:</strong>
            <span style="display: block; line-height: 1.3; min-height: 14px; white-space: nowrap;">
              [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarLocalizacao('Interna'), 2) }}</span>] Interna
              [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(marcarLocalizacao('Externa'), 2) }}</span>] Externa
            </span>
          </td>
        </tr>
      </table>
    </section>
  
    <section class="toi-pdf-secao" style="font-size: 11px;">
      <table style="width: 100%; border: 1px solid #000; background-color: #fdfdfd; border-collapse: collapse">
        <tr>
          <td style="padding: 8px; border: 1px solid #000; line-height: 2;">
            Declaro estar ciente do conteúdo deste documento, incluindo os direitos aqui transcritos. Acompanhei a
            realização da vistoria, ocasião em que recebi uma via deste termo.<br />
            <strong>Nome [ * ]:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('Nome do Acompanhante da Vistoria:'), largura: '220px' }"></ng-container>
            <strong>Assinatura:</strong>
            <ng-container *ngTemplateOutlet="assinaturaChecklist; context: { label: 'Assinatura:' }"></ng-container><br />
            <strong>Documento apresentado: Identidade Nº ou CPF Nº:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('Documento apresentado: Identidade N° ou CPF:'), largura: '120px' }"></ng-container>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('CPF N°:'), largura: '120px' }"></ng-container><br />
            <strong>[ * ] se não for o usuário, informar parentesco/afinidade com o mesmo:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: parentescoValor(), largura: '280px' }"></ng-container>
          </td>
        </tr>
      </table>
    </section>
  
    <section class="toi-pdf-secao" style="font-size: 11px;">
      <table style="width: 100%; border: 1px solid #000; background-color: #fdfdfd; border-collapse: collapse">
        <tr>
          <td style="padding: 8px; border: 1px solid #000; width: 50%; vertical-align: top; line-height: 2;">
            <strong>Testemunha Nome:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('Testemunha Nome 1:'), largura: '200px' }"></ng-container><br />
            <strong>Doc.:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('Doc Testemunha 1:'), largura: '120px' }"></ng-container>
            <strong>Assinatura:</strong>
            <ng-container *ngTemplateOutlet="assinaturaChecklist; context: { label: 'Assinatura Testemunha 1:' }"></ng-container>
          </td>
          <td style="padding: 8px; border: 1px solid #000; width: 50%; vertical-align: top; line-height: 2;">
            <strong>Testemunha Nome:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('Testemunha Nome 2:'), largura: '200px' }"></ng-container><br />
            <strong>Doc.:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: checklistValor('Doc Testemunha 2:'), largura: '120px' }"></ng-container>
            <strong>Assinatura:</strong>
            <ng-container *ngTemplateOutlet="assinaturaChecklist; context: { label: 'Assinatura Testemunha 2:' }"></ng-container>
          </td>
        </tr>
      </table>
    </section>
  
    <section class="toi-pdf-secao" style="font-size: 11px;">
      <table style="width: 100%; border: 1px solid #000; background-color: #fdfdfd; border-collapse: collapse">
        <tr>
          <td style="padding: 8px 8px 14px 8px; border: 1px solid #000; line-height: 2;">
            <strong>Empregado Copasa (autor da ocorrência):</strong><br />
            <strong>Nome:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: mascararNomePdf(pdfToi?.dadosHst?.nmResponsavelEquipe), largura: '220px' }"></ng-container>
            <strong>Nº Pessoal:</strong>
            <ng-container *ngTemplateOutlet="campoComLinha; context: { valor: pdfToi?.dadosHst?.cdResponsavelEquipe, largura: '100px' }"></ng-container>
            <strong>Assinatura:</strong>
            <ng-container *ngTemplateOutlet="assinaturaChecklist; context: { label: 'Assinatura Empregado Copasa' }"></ng-container>
          </td>
        </tr>
        <!-- Linha própria: divisor de ponta a ponta separa a recusa das assinaturas acima. -->
        <tr>
          <td style="padding: 6px 8px; border: 1px solid #000; text-align: right;">
              [<span style="color: #cc0000; font-weight: bold;">{{ marcarCheckbox(!!pdfToi?.dadosHst?.flagRecusaRecebimento) }}</span>]
              <strong>recusou recebimento em mãos</strong>
          </td>
        </tr>
      </table>
    </section>

    <!-- Rodapé do termo — modelo e vias, conforme layout oficial do TOI. Sem classe
         toi-pdf-secao para não herdar o margin-top negativo de colagem de bordas.
         line-height inteiro + padding-bottom: o html2canvas corta em scrollHeight
         (inteiro), então o texto não pode encostar na borda inferior da página. -->
    <div style="margin: 0 8px; padding: 0 6px 12px 6px; font-size: 8px; line-height: 12px;">
      TOI (modelo {{ numeroModeloToi }})&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1ª via (usuário) / 2ª via:&nbsp;&nbsp;cópia da 1ª (Copasa)
    </div>
  </div>

  <!-- Relatório fotográfico — até 10 fotos por página PDF -->
  <ng-container *ngFor="let pagina of paginasFotos; let p = index">
    <div class="page-break toi-pdf-pagina toi-pdf-pagina-break toi-pdf-fotos-pagina"
    style="page-break-before: always;
           height: 1122px;
           overflow: hidden;
           box-sizing: border-box;">        <section class="toi-pdf-secao-fotos">
        <div
          style="
            height: 70px;
            width: 100%;
            border: 1px solid #000;
            border-radius: 12px;
            background-color: #fdfdfd;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px;
            box-sizing: border-box;
            margin-bottom: 20px;
          "
        >
          <div style="width: auto; height: 40px; display: flex; align-items: center; justify-content: center">
            <img src="assets/layout/images/copasa.png" alt="Copasa" style="height: 40px; width: auto" />
          </div>
          <div style="flex-grow: 1; text-align: center; padding: 0 10px">
            <h2 style="margin: 0; font-size: 13px; color: #505050; line-height: 1.3">TERMO DE OCORRENCIA DE IRREGULARIDADE (REGULARIZAÇÃO PELA COPASA)</h2>
          </div>
          <div style="width: 100px; text-align: right">
            <span style="font-weight: bold; font-size: 9px">Página {{ p + 2 }}/{{ totalPaginas }}</span>
          </div>
        </div>
      </section>
  
      <section class="toi-pdf-secao-fotos-conteudo">
        <table style="width: 100%; border: 1px solid #000; border-collapse: collapse">
          <tbody>
            <ng-container *ngFor="let midia of pagina; let i = index">
              <tr *ngIf="i % colunasFotos === 0">
                <td
                  *ngFor="let j of colunasIndices"
                  style="padding: 4px; border: 1px solid #000; vertical-align: top; text-align: center"
                  [style.width.%]="100 / colunasFotos"
                >
                  <ng-container *ngIf="pagina[i + j]">
                    <ng-container
                      *ngTemplateOutlet="celulaMidia; context: {
                        $implicit: pagina[i + j],
                        maxHeight: fotoMaxHeightPx(pagina.length)
                      }"
                    ></ng-container>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </section>
    </div>
  </ng-container>

  <!-- Página final — informativo TOI -->
  <div class="page-break toi-pdf-pagina toi-pdf-pagina-break toi-pdf-informativo-pagina" *ngIf="tpToi === 'MODELO_2'"
  style="page-break-before: always;
         height: 1122px;
         overflow: hidden;
         box-sizing: border-box;">
  <img
      [src]="informativoToiSrc"
      alt="Informativo TOI"
      style="width: 100%; height: auto; display: block"
    />
  </div>
</div>
  
  <!-- Rótulo e valor sempre em duas linhas: o min-height reserva a 2ª linha mesmo vazio. -->
  <ng-template #campoDuasLinhas let-label="label" let-valor="valor">
    <strong style="display: block; line-height: 1.3;">{{ label }}</strong>
    <span style="display: block; line-height: 1.3; min-height: 14px;">{{ valor }}</span>
  </ng-template>

  <ng-template #campoComLinha let-valor="valor" let-largura="largura">
    <span
      [style.min-width]="largura || '140px'"
      style="display: inline-block; vertical-align: bottom; box-sizing: border-box;"
    >
      <span style="display: block; padding: 0 4px 3px 4px; line-height: 1.2; min-height: 12px;">{{ valor }}</span>
      <span style="display: block; border-bottom: 1px solid #000; height: 0;"></span>
    </span>
  </ng-template>

  <ng-template #assinaturaChecklist let-label="label" let-largura="largura" let-alturaImagem="alturaImagem">
    <span
      [style.min-width]="largura || '120px'"
      style="display: inline-block; vertical-align: bottom; text-align: center; box-sizing: border-box;"
    >
      <span
        [style.min-height.px]="alturaImagem || 24"
        style="display: block; padding: 0 4px 2px 4px; line-height: 1;"
      >
        <ng-container *ngIf="temChecklistAssinatura(label); else assinaturaTexto">
          <img
            [src]="checklistAssinaturaSrc(label)!"
            alt="Assinatura"
            crossorigin="anonymous"
            [style.max-height.px]="alturaImagem || 28"
            style="max-width: 120px; vertical-align: bottom; display: inline-block"
          />
        </ng-container>
        <ng-template #assinaturaTexto>
          <span style="display: inline-block; min-height: 12px; vertical-align: bottom;">{{ checklistValor(label) }}</span>
        </ng-template>
      </span>
      <span style="display: block; border-bottom: 1px solid #000; height: 0;"></span>
    </span>
  </ng-template>
  
  <ng-template #celulaMidia let-midia let-maxHeight="maxHeight">
    <p style="margin: 0 0 6px 0"><strong>TOI -</strong> {{ midia.legenda }}</p>
    <img
      *ngIf="midia.downloadUrl || midia.urlThumbnail"
      [src]="midia.urlThumbnail || midia.downloadUrl"
      alt="{{ midia.legenda }}"
      crossorigin="anonymous"
      [style.max-height.px]="maxHeight"
      style="width: 90%; object-fit: contain; display: block; margin: 0 auto"
    />
  </ng-template>
  